import { getWithLocaleFallback } from "./strapiApi";

// Function to fetch homepage data
export const fetchHomePageData = async (locale) => {
  return getWithLocaleFallback(
    "/home-page?populate[productPresentation][populate]=*&populate[statsSection]=*&populate[block1][populate]=*&populate[block2][populate]=*&populate[blogs][populate]=*&populate[news][populate]=*&populate[aboutSection][populate]=*&populate[productPortfolioSection][populate][categories][populate][0]=icon&populate[productPortfolioSection][populate][categories][populate][1]=image&populate[productPortfolioSection][populate][categories][populate][2]=products.image&populate[geographicPresenceSection][populate][0]=mapImage&populate[geographicPresenceSection][populate][1]=countries&populate[geographicPresenceSection][populate][2]=additionalProjects&populate[excellenceCenterSection][populate][0]=image&populate[excellenceCenterSection][populate][1]=universityPartners.image&populate[excellenceCenterSection][populate][2]=focusAreas&populate[caseStudiesSection][populate][0]=studies.image&populate[caseStudiesSection][populate][1]=studies.challenges&populate[caseStudiesSection][populate][2]=studies.benefits&populate[careersSection][populate][0]=teamImage&populate[careersSection][populate][1]=locations&populate[careersSection][populate][2]=benefits&populate[DirectorMessage][populate]=*",
    { locale, fallbackLocale: 'fr' }
  );
};

// Function to fetch slider data
export const fetchSliderData = async (locale) => {
  return getWithLocaleFallback("/sliders?populate=*", { locale, fallbackLocale: 'fr' });
};

// Function to fetch all banners (if they are stored separately)
export const fetchBanners = async (locale) => {
  return getWithLocaleFallback("/banners?populate=*", { locale, fallbackLocale: 'fr' });
};

// Function to fetch products
export const fetchProducts = async (locale) => {
  return getWithLocaleFallback("/products?populate=*", { locale, fallbackLocale: 'fr' });
};

// Function to fetch news
export const fetchNews = async (locale) => {
  return getWithLocaleFallback("/news?populate=*", { locale, fallbackLocale: 'fr' });
};

// Function to fetch industry solutions
export const fetchIndustrySolutions = async (locale) => {
  return getWithLocaleFallback("/industry-solutions?populate=*", { locale, fallbackLocale: 'fr' });
};

// Function to fetch global partners
export const fetchGlobalPartners = async (locale) => {
  return getWithLocaleFallback("/global-partners?populate=*", { locale, fallbackLocale: 'fr' });
};

export default {
  fetchHomePageData,
  fetchSliderData,
  fetchBanners,
  fetchProducts,
  fetchNews,
  fetchIndustrySolutions,
  fetchGlobalPartners,
};
